import "../../lib/jquery.magnific-popup.js";
import Swiper, { Navigation, Autoplay, Pagination } from 'swiper';
Swiper.use([Navigation, Autoplay, Pagination]);


declare var s7viewers:any;
declare var addthis:any;

const enum URLs {
	IMAGE_BASE_URL = 'https://images.national-hardware.com/is/image/',
	SCENE7_VIDEO_BASE_URL = 'https://images.national-hardware.com/is/content/',
	SKINS_BASE_URL = 'https://images.national-hardware.com/is/image/skins/',
	DOWNLOAD_IMAGE_URL = '/product/downloadimage?imageurl=',
}

const enum CONFIG {
	DEFAULT_SKIN = 'CONFIG.DEFAULT_SKIN'
}

namespace NHW.controllers.modal {
	function getParameterByName(name, url?) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	//strip out empty items in array
	function cleanArray(actual) {
		var newArray = new Array();
		for (var i = 0; i < actual.length; i++) {
			if (actual[i]) {
				newArray.push(actual[i]);
			}
		}
		return newArray;
	}

	function checkForBeginningAndEnd() {
		let $selectedSlide = $('.swiper-slide-selected');
		let $nextArrow = $('.js-next-arrow');
		let $prevArrow = $('.js-prev-arrow');
		(!$selectedSlide.next('.swiper-slide').length) ? $nextArrow.addClass('disabled') : $nextArrow.removeClass('disabled');
		(!$selectedSlide.prev('.swiper-slide').length) ? $prevArrow.addClass('disabled') : $prevArrow.removeClass('disabled');
	}

	function passIDBuildList() {
		// here were grabbing query string param values that get passed through so we can work with the data

		var queryStringValues = getParameterByName('ids');
		var selectedItemID = getParameterByName('selectedItem');

		//performing a split on the ids coming through
		var splitValues = queryStringValues.split(',');
		var joinedValues = splitValues.join(',');
        
		 //perform our string splits to get different segments of incoming data
		 let imageIds = joinedValues.split('clippedids:')[0] != null ? joinedValues.split('clippedids:')[0] : '';
		 let galleryimageIds = joinedValues.split('clippedids:')[0] != null ? joinedValues.split('clippedids:')[0] : '';    
		 let clippedSegment = joinedValues.split('clippedids:')[1] != null ? joinedValues.split('clippedids:')[1] : '';
		 let clippedimageIds = clippedSegment.split('vignetteids:')[0] != null ? clippedSegment.split('vignetteids:')[0] : ''; 
		 let vignetteSegment = joinedValues.split('vignetteids:')[1] != null ? joinedValues.split('vignetteids:')[1] : '';
		 let vignetteimageIds = vignetteSegment.split('supplementaryids:')[0] != null ? vignetteSegment.split('supplementaryids:')[0] : '';    
		 let supplementarySegment = joinedValues.split('supplementaryids:')[1] != null ? joinedValues.split('supplementaryids:')[1] : '';
		 let supplementaryimageIds = supplementarySegment.split('lifestyleids:')[0] != null ? supplementarySegment.split('lifestyleids:')[0] : '';    
		 let lifestyleSegment = joinedValues.split('lifestyleids:')[1] != null ? joinedValues.split('lifestyleids:')[1] : '';
		 let lifestyleimageIds = lifestyleSegment.split('packagingids:')[0] != null ? lifestyleSegment.split('packagingids:')[0] : '';    
		 let packagingSegment = joinedValues.split('packagingids:')[1] != null ? joinedValues.split('packagingids:')[1] : '';
		 let packagingimageIds = packagingSegment.split('websiteids:')[0] != null ? packagingSegment.split('websiteids:')[0] : '';  
		 let websiteVideoSegment = joinedValues.split('websiteids:')[1] != null ? joinedValues.split('websiteids:')[1] : '';
		 let websiteVideoIds = websiteVideoSegment.split('installationids:')[0] != null ? websiteVideoSegment.split('installationids:')[0] : ''; 
		 let installationVideoSegment = joinedValues.split('installationids:')[1] != null ? joinedValues.split('installationids:')[1] : '';
		 let installationVideoIds = installationVideoSegment.split('threesixty:')[0] != null ? installationVideoSegment.split('threesixty:')[0] : '';  		 
		 let threeSixtyIds = joinedValues.split('threesixty:')[1] != null ? joinedValues.split('threesixty:')[1] : '';
		 
	 
		 //concatenate and check for length of combined types
		 let concatenatedString = galleryimageIds.concat(clippedimageIds, vignetteimageIds, supplementaryimageIds, lifestyleimageIds, packagingimageIds, websiteVideoIds, installationVideoIds, threeSixtyIds);
		 let itemsLength = cleanArray(concatenatedString.split(',')).length;
	 
		 //create objects from specific segments
		 let allImagesArray = cleanArray(concatenatedString.split(','));
		 let galleryimagesArray = cleanArray(galleryimageIds.split(','));
		 let clippedimagesArray = cleanArray(clippedimageIds.split(','));		
		 let vignetteimagesArray = cleanArray(vignetteimageIds.split(','));
		 let supplementaryimagesArray = cleanArray(supplementaryimageIds.split(','));
		 let lifestyleimagesArray = cleanArray(lifestyleimageIds.split(','));	
		 let packagingimagesArray = cleanArray(packagingimageIds.split(','));
		 let websiteVideoArray = cleanArray(websiteVideoIds.split(','));
		 let installationVideoArray = cleanArray(installationVideoIds.split(','));			 
		 let threeSixtyArray = cleanArray(threeSixtyIds.split(','));
	 
		//need to seperate out mutliple id from single id so split does not fail if only 1 id.
		var properID = selectedItemID != null ? selectedItemID : allImagesArray[0];
		var isSingleID = itemsLength < 2 || getParameterByName('singleImage');
		let $body = $('body');

		// full image url
		if(allImagesArray.length) {
			var fullImageUrl = URLs.IMAGE_BASE_URL + properID + '?$nhwFullResProduct$';
		}

		//setup other vars
		var $carousel = $('.js-product-carousel');

		//check for a query param indicating that there is only 1 id coming through and add class so we can style differently
		if (isSingleID || itemsLength < 2) {
			$body.addClass('single-element');
		}

		//if there is more than one id coming through then loop through the ids and add the image to carousel, if not we dont do this.
		if (!isSingleID) {
			
			if(galleryimagesArray.length)
			{
				$.each(galleryimagesArray, function (i) {
					let theID = galleryimagesArray[i];
					let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
					$(`<div class="product-carousel__list-item swiper-slide">
							<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
								<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Gallery Image for ${encodedID}">
							</a>
						</div>`).appendTo($carousel);
				});
			}
			if(packagingimagesArray.length)
            {
            $.each(packagingimagesArray, function (i) {
                let theID = packagingimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Packaging Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
            } 
			if(lifestyleimagesArray.length)
        	{
            $.each(lifestyleimagesArray, function (i) {
                let theID = lifestyleimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Lifestyle Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        	}  
			if(supplementaryimagesArray.length)
			{
				$.each(supplementaryimagesArray, function (i) {
					let theID = supplementaryimagesArray[i];
					let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
					$(`<div class="product-carousel__list-item swiper-slide">
							<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
								<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Supplementary Image for ${encodedID}">
							</a>
						</div>`).appendTo($carousel);
				});
			}      
			
			if(vignetteimagesArray.length)
            {
            $.each(vignetteimagesArray, function (i) {
                let theID = vignetteimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Vignette Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
            } 
			if(clippedimagesArray.length)
			{
				$.each(clippedimagesArray, function (i) {
					let theID = clippedimagesArray[i];
					let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
					$(`<div class="product-carousel__list-item swiper-slide">
							<a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
								<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Clipped Image for ${encodedID}">
							</a>
						</div>`).appendTo($carousel);
				});
			} 
			//insert 360 Images into the carousel
			$.each(threeSixtyArray, function (i) {
				var theID = threeSixtyArray[i];

				var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
				$(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link-threesixty product-carousel__link">
						<i class="icon icon-logo"></i>
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$features$" class="product-carousel__img" alt="360 Image of ${encodedID}">
					</a>
				</div>`).appendTo($carousel);
			});
		}
		if(websiteVideoArray.length)
        {
        //insert website video thumbs into carousel
            $.each(websiteVideoArray, function (i) {
                var theID = websiteVideoArray[i];
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link-youtube product-carousel__link">
                            <img src="https://img.youtube.com/vi/${theID}/mqdefault.jpg" class="product-carousel__img" alt="websitevideo Thumbnail ${theID}">
                            <div class="icon-logo-clear"><span class="icon-play"></span></div>
                        </a>
                    </div>`).appendTo($carousel);
            });
        }
		if(installationVideoArray.length)
        {
        //insert installation video thumbs into carousel
            $.each(installationVideoArray, function (i) {
                var theID = installationVideoArray[i];
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link-youtube product-carousel__link">
                            <img src="https://img.youtube.com/vi/${theID}/mqdefault.jpg" class="product-carousel__img" alt="installation video Thumbnail ${theID}">
                            <div class="icon-logo-clear"><span class="icon-play"></span></div>
                        </a>
                    </div>`).appendTo($carousel);
            });
        }

		// Swiper seems to expand slides fill the available space, so if there are only two we'll have to make the carousel shorter
		if (itemsLength < 3) {
			$('.swiper-container').addClass('swiper-container--short');
		}

		//initialize swiper with the current slide set to 0 if there is no selected item being passed through a query param
		//OR if selected item is being passed through we set the initial slide to the selected items parent index value

		let slidesPerView = Math.min( itemsLength, 3 );
		var mySwiper;

		if (!isSingleID) {
			var wrapperElements = document.querySelectorAll(".product-carousel__left-col-content");

			//need to do this because our arrows our outside of swiper container
			for(var i = 0; i < wrapperElements.length; i++) {
				var el = wrapperElements[i];
				var swiper = el.querySelector(".swiper-container");
				var nx = el.querySelector(".swiper-button-next");
				var pr = el.querySelector(".swiper-button-prev");

				mySwiper = new Swiper(swiper, {
					direction: (window.innerWidth >= 768) ? 'vertical' : 'horizontal',
					slidesPerView: slidesPerView,
					spaceBetween: 20,
					init: false,
					initialSlide: selectedItemID != null ? $(`a[data-id="${selectedItemID}"]`).parent().index() : 0,
					keyboardControl: true,

					navigation: {
						nextEl: nx,
						prevEl: pr
					}
				});
			}
		}

		if (!isSingleID) {
			mySwiper.on('init', function () {
				setTimeout(function(){
					if(selectedItemID != null ) {
						mySwiper.activeIndex = $(`a[data-id="${selectedItemID}"]:first`).parent().index();
					}
					if(mySwiper.activeIndex == -1) {
						mySwiper.activeIndex = 0;
					}

					$('.swiper-slide').removeClass('swiper-slide-selected');
					$(mySwiper.slides[mySwiper.activeIndex]).addClass("swiper-slide-selected");
					$(mySwiper.slides[mySwiper.activeIndex]).find('a[class^="js-carousel-link"]').trigger("click");
				}, 300);
			});
		}

		// Set the download link to match the large image
		$('.icons-block__link').eq(0).attr('href', fullImageUrl);
		$('.icons-block__link').eq(0).attr('download', fullImageUrl);

		// Set the share link to set up for Add This for the large image
	

		if(allImagesArray.length) {
			/**
			 * https://stackoverflow.com/questions/15367134/change-addthis-url-dynamically-with-jquery
			 * This page has information on this element of the api I could not find this on the addthis site
			 */
		
			//setup the initial scene7 Zoom Viewer.

			let s7basiczoom_div = new s7viewers.BasicZoomViewer({
				"containerId": "s7basiczoom_div",
				"params": {
					"asset": properID,
					"serverurl": URLs.IMAGE_BASE_URL,
					"contenturl": URLs.SCENE7_VIDEO_BASE_URL,
					"config": CONFIG.DEFAULT_SKIN
				}
			}).init();
		}

		if (mySwiper) {
			mySwiper.init();

			mySwiper.on('resize', function(){
				mySwiper.update();
			});
		}

		//When we click on a carousel item link in the modal were reinitializing the BasicZoomViewer with the correct asset id
		$body.on('click', '.js-carousel-link', function (e) {
			$('#s7viewer').remove();
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			$('.icons-list').removeAttr('style');

			$(`<div id="s7basiczoom_div" />`).prependTo($(".product-carousel__right-col"));
			let s7basiczoom_div:any = new s7viewers.BasicZoomViewer();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			let idOfElement = $(this).data('id');
			let zoomViewerParent = $('#s7basiczoom_div');
			e.preventDefault();
			zoomViewerParent.empty();
			checkForBeginningAndEnd();

			let fullImageUrl = URLs.IMAGE_BASE_URL + idOfElement + '?$nhwFullResProduct$';
			//console.log(fullImageUrl);
			//console.log(s7basiczoom_div);

			// Update the download link to match the large image
			//$('.icons-block__link').eq(0).attr('href', fullImageUrl);
			$('.icons-block__link').eq(0).attr('href', URLs.DOWNLOAD_IMAGE_URL + URLs.IMAGE_BASE_URL + idOfElement + "&imagename="+ idOfElement);

			// Set the share link to set up for Add This for the large image
			$('.addthis_button_compact').attr({
				href: 'http://api.addthis.com/oexchange/0.8/offer?url=' + fullImageUrl
			});

			// console.log(`full image url is: ${fullImageUrl}`);

			/**
			 * https://stackoverflow.com/questions/15367134/change-addthis-url-dynamically-with-jquery
			 * This page has information on this element of the api I could not find this on the addthis site
			 */
		//	addthis.update('share', 'url', fullImageUrl);
		//	addthis.update('share', 'title', 'National Hardware');
		//	addthis.update('share', 'media', fullImageUrl);

			s7basiczoom_div = new s7viewers.BasicZoomViewer({
				"containerId": "s7basiczoom_div",
				"params": {
					"asset": idOfElement,
					"serverurl": URLs.IMAGE_BASE_URL,
					"contenturl": URLs.SCENE7_VIDEO_BASE_URL,
					"config": CONFIG.DEFAULT_SKIN
				}
			}).init();

			//console.log(s7basiczoom_div);
		});

		$body.on('click', '.js-prev-arrow', function(e){
			let $selectedSlide = $('.swiper-slide-selected');
			if($selectedSlide.prev('.swiper-slide').length) {
				$('.js-next-arrow').removeClass('disabled');
				$selectedSlide.prev('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
			} else {
				$(this).addClass('disabled');
			}
			e.preventDefault();
		});

		$body.on('click', '.js-next-arrow', function(e){
			let $selectedSlide = $('.swiper-slide-selected');
			if($selectedSlide.next('.swiper-slide').length) {
				$('.js-prev-arrow').removeClass('disabled');
				$selectedSlide.next('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
			} else {
				$(this).addClass('disabled');
			}
			e.preventDefault();
		});

		$body.on('click', '.js-carousel-link-youtube', function (e) {
			$('#s7viewer').remove();
			var $this = $(this);
			var $youtubeID = $this.data('id');
			$('.icons-list').hide();
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			e.preventDefault();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			$(`<div class="embed-responsive embed-responsive-16by9"><iframe width="845" height="476" src="https://www.youtube.com/embed/${$youtubeID}?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`).prependTo($(".product-carousel__right-col"));
			checkForBeginningAndEnd();
		});

		$body.on('click', '.js-carousel-link-scene7', function (e) {
			$('#s7viewer').remove();
			var $this = $(this);
			$('.icons-list').hide();
			var $scene7ID = $this.data('id');
			var encodedID = $scene7ID.replace('-', '%2D').replace(' ', '%20');
			$('#s7basiczoom_div').remove();
			$('.embed-responsive').remove();
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');
			e.preventDefault();
			$(`<div class="embed-responsive embed-responsive-16by9"><video width="845" height="476" id="scene7Vid" controls autoplay>
                <source src="${URLs.SCENE7_VIDEO_BASE_URL}/${encodedID}" type="video/mp4">
					Your browser does not support the video tag.
				</video></div>`).prependTo($(".product-carousel__right-col"));
			($('#scene7Vid').get(0) as any).play();
			checkForBeginningAndEnd();
		});

		$body.on('click', '.js-carousel-link-threesixty', function (e) {
			$('#s7basiczoom_div').remove();
			$('#s7viewer').remove();
			$('.embed-responsive').remove();
			$(`<div id="s7viewer" />`).prependTo($(".product-carousel__right-col"));
			var spinViewer = new s7viewers.SpinViewer();
			var $this = $(this);
			$('.icons-list').hide();
			var $theeSixtyID = $this.data('id');
			$('.swiper-slide').removeClass('swiper-slide-selected');
			$(this).parent('.swiper-slide').addClass('swiper-slide-selected');

			var spinViewerParent = $('#s7viewer');

			e.preventDefault();
			spinViewerParent.empty();

			var spinViewer = new s7viewers.SpinViewer({
				"containerId":"s7viewer",
				"params":{
					"asset": $theeSixtyID,
					"serverurl": URLs.IMAGE_BASE_URL,
				}
			}).init();
			checkForBeginningAndEnd();
		});

		setTimeout(function(){
			$('.js-load-indicator').removeClass('state-loading');
			$('.js-load-indicator-cover').addClass('state-hidden');
		}, 1200);
	}

	function addThisHooks(){
		let closeButton = $('button.mfp-close',parent.document);
		$('body').on('click', '.js-addthis-share', function(e){
			$('body').off('click', '.at-expanded-menu-close');
			setTimeout(function(){
				closeButton.addClass('hidden');
				$('body').on('click', '.at-expanded-menu-close', function(){
					closeButton.removeClass('hidden');
				})
			}, 20);
		});
	}

	export function init() {
		passIDBuildList();
	//	addThisHooks();
	}
}

NHW.controllers.modal.init();
